export default {"src":"/login-app/[GIT_HASH]/_next/static/media/visibility.8aa23689.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};